<div class="popup">
  <nb-card>
    <nb-card-body>
      <div *ngIf="orderInfo">
        <h1>Заказ №{{ orderInfo.id }} оформлен.</h1>
          <div class="date-delivery">
              <div class="date-delivery__right">
                  <p i18n="@@Total">Итого:</p>
                  <p>
                      <span class="price-main">{{ (totalCost | formatPriceNumber).main }}</span>
                      <span class="price-cents">.{{ (totalCost | formatPriceNumber).cents }}</span>
                      <span class="curr"> ₽</span>
                  </p>
              </div>
              <div class="date-delivery__right">
                  <p i18n="@@TotalWithVat">Итого с НДС:</p>
                  <p>
                      <span class="price-main">{{ (totalCostVAT | formatPriceNumber).main }}</span>
                      <span class="price-cents">.{{ (totalCostVAT | formatPriceNumber).cents }}</span>
                      <span class="curr"> ₽</span>
                  </p>
              </div>
          </div>
        <nb-card-footer>
          <button nbButton
                  status="primary"
                  fullWidth
                  size="large"
                  i18n="@@OpenOrder"
                  type="button"
                  (click)="go()">
            Открыть заказ
          </button>
        </nb-card-footer>
      </div>

      <form aria-labelledby="title" [formGroup]="inputForm" (ngSubmit)="onSubmit()" *ngIf="!orderInfo">
        <h1 i18n="@@RequestInvoice">Запрос счёта на оплату</h1>
        <p *ngIf="!fail" i18n="@@RequestInvoiceDescription">Для оформления заказа выберите точку самовывоза или адрес доставки</p>
        <p *ngIf="fail" i18n="@@OrderRejected" class="alert alert-warning">Не удалось обработать заказ. Повторите попытку позже</p>


        <div class="form-content">
          <div class="form-content__top">
            <nb-radio-group formControlName="deliveryMethod" [(ngModel)]="deliveryMethod">
              <nb-radio [value]="option.value" *ngFor="let option of deliveryMethodOptions">
                {{ option.label }}
              </nb-radio>
            </nb-radio-group>
          </div>
          <div *ngIf="isPickup()" class="form-control-group">
            <label class="label" i18n="@@SelfPickPoint">Пункт самовывоза *</label>
            <div>
              <nb-select fullWidth i18n-placeholder="@@ChooseAddress"
                         [(ngModel)]="pickupAddress"
                         placeholder="Выберите адрес"
                         formControlName="pickupAddress">
                <nb-option *ngFor="let address of pickupAddresses$ | async" [value]="address.id">{{ address.header }}</nb-option>
              </nb-select>
            </div>
          </div>
          <div *ngIf="isDelivery()" class="form-control-group">
            <label class="label" i18n="@@DeliveryAddress">Адрес доставки *</label>
            <div>
              <nb-select fullWidth i18n-placeholder="@@ChooseAddress"
                         [(ngModel)]="deliveryAddress"
                         placeholder="Выберите адрес"
                         formControlName="deliveryAddress">
                <nb-option *ngFor="let address of deliveryAddresses$ | async" [value]="address.id">{{ address.header }}</nb-option>
                <nb-option *ngIf="selectedAddress!=null" [value]="selectedAddress.id">{{ selectedAddress.header }}</nb-option>
              </nb-select>
            </div>
          </div>
          <div class="form-control-group">
            <label class="label" i18n="@@ManagerComment">Комментарий для менеджера</label>
            <textarea fullWidth nbInput type="text" name="comment" formControlName="comment"></textarea>
          </div>
        </div>

        <div class="date-delivery">
          <div class="date-delivery__right">
            <p i18n="@@Total">Итого:</p>
            <p>
              <span class="price-main">{{ (totalCost | formatPriceNumber).main }}</span>
              <span class="price-cents">.{{ (totalCost | formatPriceNumber).cents }}</span>
              <span class="curr"> ₽</span>
            </p>
          </div>
            <div class="date-delivery__right">
                <p i18n="@@TotalWithVat">Итого с НДС:</p>
                <p>
                    <span class="price-main">{{ (totalCostVAT | formatPriceNumber).main }}</span>
                    <span class="price-cents">.{{ (totalCostVAT | formatPriceNumber).cents }}</span>
                    <span class="curr"> ₽</span>
                </p>
            </div>
        </div>
        <nb-card-footer>
          <button nbButton
                  fullWidth
                  status="primary"
                  size="large"
                  i18n="@@ReceiveInvoice"
                  type="submit" [nbSpinner]="submitted" nbSpinnerStatus="control" [disabled]="!validForm() || submitted">
            Получить счет
          </button>
        </nb-card-footer>
      </form>
    </nb-card-body>
  </nb-card>
</div>
